module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tools:filter":"Все фильтры","tools:columns":"Настройка отображаемых столбцов"},"en":{"tools:filter":"Filters","tools:columns":"Customize display columns"}}')
  delete Component.options._Ctor
}
